import { render, staticRenderFns } from "./NationalTrademarkSearchResponsibleForm.vue?vue&type=template&id=59091b3b&"
import script from "./NationalTrademarkSearchResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkSearchResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports